(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instacache"] && !Shopify.designMode) return;
  try {
    
  (function($) {
    var modelOpenId = null;

    
    $('body').on('click', '.insta-cache-modal-selector', function(){
      openModal($(this).data('src'));
    });
    

    $('body').on('click', 'div.instagram-modal-close-button', function() {
      closeAllModals();
    });

    $.fn.extend({
        center: function() {
          var top = $(window).scrollTop();
          var left = ((window.innerWidth - this.outerWidth()) / 2) + $(window).scrollLeft();

          if (window.matchMedia('(min-width: 640px)').matches) {
            top = ((window.innerHeight - this.outerHeight()) / 2) + $(window).scrollTop();
          }

          this.css({
            "position": "absolute",
            "top": (top + "px"),
            "left": (left + "px")
          });
        }
      });

      function openModal(id){
        closeAllModals();

        $('body').append('<div id="modal-overlay"></div>');
        $('#modal-overlay').on('click', function() {
          closeAllModals();
        });

        $('#' + id).clone().attr('id', id + '-active').appendTo('body');
        $('#' + id + '-active').center();

        modelOpenId = id;
      }

      function closeAllModals() {
        $('body > .instagram-modal').remove();
        $('#modal-overlay').remove();

        modelOpenId = null;
      }

      window.addEventListener("keydown", function (event) {
        if (event.defaultPrevented || openModal == null) {
          return; // Do nothing if the event was already processed
        }

        switch (event.key) {
          case "Left": // IE/Edge specific value
          case "ArrowLeft":
            $('#' + modelOpenId + '-active .instagram-modal-navigator > a').first().trigger('click');
            break;
          case "Right": // IE/Edge specific value
          case "ArrowRight":
            $('#' + modelOpenId + '-active .instagram-modal-navigator > a').last().trigger('click');
            break;
          case "Esc": // IE/Edge specific value
          case "Escape":
            closeAllModals();
            break;
          default:
            return; // Quit when this doesn't handle the key event.
        }

        // Cancel the default action to avoid it being handled twice
        event.preventDefault();
      }, true);
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector('section[data-section-type=product-recommendations]');
  if (productRecommendationsSection === null) { return; }
  var options = JSON.parse(productRecommendationsSection.getAttribute('data-section-settings'));
  if (options['useRecommendations']) { return; }
  var carousel = productRecommendationsSection.querySelector('.Carousel')
  var flickity = Flickity.data(carousel)
  var requestUrl = '/recommendations/products?section_id=product-recommendations&product_id=' + options['productId'] + '&limit=' + options['recommendationsCount'];
  var request = new XMLHttpRequest();
  request.open('GET', requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var productIds = [];
      var relatedProducts = productRecommendationsSection.querySelectorAll('.Carousel__Cell');
      for (item of relatedProducts) { 
        var productId = item.dataset.productId;
        productIds.push(productId);                                                                                 
      }
      var container = document.createElement('div');
      container.innerHTML = request.response;                                                 
      recommendationProducts = container.querySelectorAll('.Carousel__Cell');         
      var productList = container.querySelector('.ProductList');                                              
      for (item of recommendationProducts) {
        var productId = item.dataset.productId;
        if (! productIds.includes(productId) && productIds.length < 5) {
          flickity.append(item);
          productIds.push(productId);
        }
      } 
    }
  };
  request.send();
};

document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId === 'product-recommendations') {
    loadProductRecommendationsIntoSection();
  }
}); 
                                                      
document.addEventListener('DOMContentLoaded', function() {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
